import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../helpers/translate.helper';
import { getSidebarShortcutLabel, useSidebar } from '../../hooks/useSidebar';
import { IconLayoutSidebarLeftCollapse } from '../../icons/cdl/LayoutSidebarLeftCollapse';
import { IconLayoutSidebarLeftExpand } from '../../icons/cdl/LayoutSidebarLeftExpand';
import { Box } from '../../ui/Box';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const ToggleSidebar = () => {
    const { isFixed, toggle } = useSidebar();
    const { setOpen } = useShortcutMenu();

    const Icon = isFixed ? IconLayoutSidebarLeftCollapse : IconLayoutSidebarLeftExpand;
    const label = isFixed ? 'shortcutMenu.collapseSidebar' : 'shortcutMenu.showSidebar';
    const shortcutLabel = getSidebarShortcutLabel();

    return (
        <CommandItem
            onSelect={() => {
                toggle();
                setOpen(false);
            }}
            Icon={Icon}
            trailingVisual={
                <Box aria-label={shortcutLabel}>
                    <Text variant="extraSmall" color="foreground.subtle">
                        {shortcutLabel}
                    </Text>
                </Box>
            }
        >
            {translate(label)}
        </CommandItem>
    );
};
